/*
 * Copyright (c) 2020-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

/**
 * Renders toasts from useToast() (hooks/use-toast).
 * The main Toaster in App renders toasts from the Zustand store (useToasts).
 * Pages that call toast() from useToast() need this component to see their toasts.
 */
import { useToast } from "@/hooks/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";

export function HookToaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(({ id, title, description, variant, open, onOpenChange, ...rest }) => (
        <Toast key={id} variant={variant} open={open} onOpenChange={onOpenChange} {...rest}>
          <div className="grid gap-1">
            {title && <ToastTitle>{title}</ToastTitle>}
            {description && <ToastDescription>{description}</ToastDescription>}
          </div>
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport label="Form and dialog toasts ({hotkey})" />
    </ToastProvider>
  );
}
